import { API_ENDPOINTS } from "./apiCall";

const BASE = `${API_ENDPOINTS.API_COMMAN_URL}UserGuide/`;


export const User_Guide_Api = {
    user_guide_crud:{
         list: `${BASE}user_guide-list`,
         list_by_id:`${BASE}user_guide-list-by-id`,
    }
    };